import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DelimiterSettingState } from '@store/reducers';

export const selectDelimiterSettingState = createFeatureSelector<DelimiterSettingState>('delimiterSetting');

export const selectDelimiterSettingLoading = createSelector(
  selectDelimiterSettingState,
  (state: DelimiterSettingState) => state.loading
);

export const selectDelimiterSettingEditMode = createSelector(
  selectDelimiterSettingState,
  (state: DelimiterSettingState) => state.editMode
);

export const selectDelimiterSettingIsEditing = createSelector(
  selectDelimiterSettingState,
  (state: DelimiterSettingState) => state.isEditing
);

export const selectDelimiterSettingId = createSelector(
  selectDelimiterSettingState,
  (state: DelimiterSettingState) => state.delimiterSettingId
);

export const selectDelimiterSetting = createSelector(
  selectDelimiterSettingState,
  (state: DelimiterSettingState) => state.delimiterSetting
);

export const selectDelimiterSettingList = createSelector(
  selectDelimiterSettingState,
  (state: DelimiterSettingState) => state.delimiterSettingList
);

export const selectDelimiterSettingForm = createSelector(
  selectDelimiterSettingState,
  (state: DelimiterSettingState) => state.delimiterSettingForm
);

export const selectDelimiterSettingFormValid = createSelector(
  selectDelimiterSettingState,
  (state: DelimiterSettingState) => state.formValid
);

export const selectDelimiterSettingInmutable = createSelector(
  selectDelimiterSettingState,
  (state: DelimiterSettingState) => state.delimiterSettingInmutable
);

export const selectDelimiterSettingError = createSelector(
  selectDelimiterSettingState,
  (state: DelimiterSettingState) => state.error
);